import { useCallback } from '@wordpress/element'
import { BaseProps } from '../types'

type StaffNoTablistBlockProps = {
  manager_title: string
  staff_title: string
  leaders: any[]
  teachers: any[]
}

export default function TeamBlockNoTablist(props: BaseProps<StaffNoTablistBlockProps>) {
  const { manager_title, staff_title, leaders = [], teachers = [] } = props.data || {}

  const renderList = useCallback((data: any[]) => {
    if (!Array.isArray(data) || data.length === 0) return null
    return (
      <div className="flex justify-center">
        <div className="flex flex-wrap justify-center">
          {data.map((item, index) => (
            <div
              key={index}
              className="border my-[10px] mx-[10px] xl:w-[350px] 2xl:w-[420px] justify-center items-center min-w-[116px] rounded-[10px] overflow-hidden bg-blue-50"
            >
              <div className="flex justify-center h-[252px] bg-white">
                <img
                  className="h-[252px] object-cover"
                  alt=""
                  src={item.avatar || item.image_url}
                />
              </div>
              <div className="text-center font-exo p-4 2xl:p-10">
                <div className="font-bold text-subtitle relative text-primary flex justify-center items-center">
                  {item.name}
                </div>
                <div className="text-primary text-subtitle italic">
                  {item.title}
                </div>
                <div dangerouslySetInnerHTML={{ __html: item.description }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }, [])

  if (!props.data) return null

  return (
    <div>
      {/* Section 1: Managers / Leaders */}
      {leaders.length > 0 && (
        <section className="mb-[70px]">
          {manager_title && (
            <h3 className="text-center text-primary font-bold text-subtitle mb-[33px]">
              {manager_title}
            </h3>
          )}
          {renderList(leaders)}
        </section>
      )}

      {/* Section 2: Teachers / Staffs */}
      {teachers.length > 0 && (
        <section>
          {staff_title && (
            <h3 className="text-center text-primary font-bold text-subtitle mb-[33px]">
              {staff_title}
            </h3>
          )}
          {renderList(teachers)}
        </section>
      )}
    </div>
  )
}